import '../styles/loader.scss';

const Loader = () => (
    <div className="true-comply_loader">
        <div className="a-loading a-primary" />
        <div className="a-mt-10 a-h6 a-apply-theme-font-default-white">Loading...</div>
    </div>
);

export default Loader;
